import { useState } from 'react';
import Layout from '../shared/Layout';
import PageHeader from '../shared/PageHeader';
import FilterBar from '../../components/settings/FilterBar';
import IconAdd from '../../components/icons/IconAdd';
import usePersistedState from '../../hooks/usePersistedState';
import GamesTab from './GamesTab';
import SetsTab from './SetsTab';
import GameModal from './GameModal';
import SetModal from './SetModal';
import { GAME_TYPE_LIST } from '../../variables/gameTypes';
import '../../css/groups.css';
import '../../css/games.css';

// Hub for the unified games module: two tabs ("Ігри" / "Набори") replacing
// the old separate /games /set /grid /quiz /letters /matching pages.
const Games = () => {
   const [activeTab, setActiveTab] = usePersistedState('games-hub-tab', 'games');
   const [search, setSearch] = useState('');
   const [typeFilter, setTypeFilter] = useState('');
   const [refresh, setRefresh] = useState(0);

   const [gameModalState, setGameModalState] = useState('none');
   const [setModalState, setSetModalState] = useState('none');
   const [editGameId, setEditGameId] = useState(null);
   const [editSetId, setEditSetId] = useState(null);

   const bump = () => setRefresh(prev => prev + 1);

   const openCreate = () => {
      if(activeTab === 'games') { setEditGameId(null); setGameModalState('create'); }
      else { setEditSetId(null); setSetModalState('create'); }
   };
   const openEditGame = (id) => { setEditGameId(id); setGameModalState('edit'); };
   const openEditSet = (id) => { setEditSetId(id); setSetModalState('edit'); };
   const closeGameModal = () => setGameModalState('none');
   const closeSetModal = () => setSetModalState('none');
   const onGameSaved = () => { closeGameModal(); bump(); };
   const onSetSaved = () => { closeSetModal(); bump(); };

   return (
      <Layout>
         <PageHeader name="Ігри">
            <FilterBar
               search={{ value: search, onChange: setSearch, placeholder: 'Пошук...' }}
               filters={activeTab === 'games' ? [
                  { key: 'type', type: 'select', label: 'Усі типи',
                     options: GAME_TYPE_LIST.map(gt => ({ id: gt.type, name: gt.label })),
                     value: typeFilter, onChange: setTypeFilter, numeric: true },
               ] : []}
            />
            <div className="groups-header-actions">
               <div className="groups-add-btn" onClick={openCreate} title={activeTab === 'games' ? 'Нова гра' : 'Новий набір'}>
                  <IconAdd />
               </div>
            </div>
         </PageHeader>
         <main className="main-block">
            <div className="main-content txt-c games-page">
               <div className="student-card-tabs">
                  <div className={"student-card-tab" + (activeTab === "games" ? " active" : "")} onClick={() => setActiveTab("games")}>
                     Ігри
                  </div>
                  <div className={"student-card-tab" + (activeTab === "sets" ? " active" : "")} onClick={() => setActiveTab("sets")}>
                     Набори
                  </div>
               </div>

               {activeTab === 'games'
                  ? <GamesTab search={search} typeFilter={typeFilter} refresh={refresh} onEdit={openEditGame} />
                  : <SetsTab search={search} refresh={refresh} onEdit={openEditSet} />}
            </div>
         </main>

         <GameModal modalState={gameModalState} gameId={editGameId} onClose={closeGameModal} onSaved={onGameSaved} />
         <SetModal modalState={setModalState} setId={editSetId} onClose={closeSetModal} onSaved={onSetSaved} />
      </Layout>
   );
};

export default Games;
